import { Component, Input, inject } from "@angular/core"
import { MatDialog } from "@angular/material/dialog"
import { MatIcon } from "@angular/material/icon"
import { MatTooltip } from "@angular/material/tooltip"
import { FileDialogComponent } from "./file-dialog.component"

@Component({
    selector: "valben-file-modal",
    standalone: true,
    template: `
        <button
            type="button"
            class="valben-row-action"
            [attr.aria-label]="tooltip"
            [matTooltip]="tooltip"
            (click)="open()">
            <mat-icon>{{ icon }}</mat-icon>
        </button>`,
    imports: [MatIcon, MatTooltip],
})
export class FileModalComponent {
    @Input() src: string = ""
    @Input() icon: string = "image"
    @Input() tooltip: string = "Prikaži"

    private readonly _dialog = inject(MatDialog)

    open(): void {
        this._dialog.open(FileDialogComponent, {
            data: this.src,
            width: "fit-content",
            // Raised off MatDialog's 80vw default so the 85vw media below isn't clipped.
            maxWidth: "90vw",
        })
    }
}
